import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import StorefrontIcon from '@mui/icons-material/Storefront';
import EditIcon from '@mui/icons-material/Edit';

import ColumnAvatar from '../components/Redesing/column-avatar';
import { SeverityPill } from '../components/Redesing/severity-pill';
import IconButtonMenu from '../components/Redesing/icon-button-menu';
import { history } from '../utils';
import type { IMerchantStore } from '../hooks/merchantStores/query/V2';

const statusColor = (status: string) => {
  switch (status) {
    case 'Live':
      return 'success';
    case 'Retired':
      return 'error';
    default:
      return 'info';
  }
};

export const merchantStoreColumns = [
  {
    id: 'name',
    label: 'Merchant',
    searchable: true,
    format: (row: IMerchantStore) => (
      <ColumnAvatar
        avatar={
          row.logo_url ? (
            <Avatar src={row.logo_url} alt={row.name} variant="rounded" />
          ) : (
            <StorefrontIcon />
          )
        }
        avatarColor={row.primary_color || undefined}
        firstRow={
          <Typography color="text.primary" variant="body1">
            {row.name}
          </Typography>
        }
        secondRow={
          <Typography color="text.secondary" variant="body2">
            <SeverityPill color={statusColor(row.status)}>{row.status}</SeverityPill>
          </Typography>
        }
      />
    ),
  },
  { id: 'website_url', label: 'Website', notSortable: true },
  // Export-only: `hidden` keeps them out of the table but PaginationTable's
  // CSV takes every column that is not `shouldNotExport`.
  { id: 'lat', label: 'Latitude', hidden: true },
  { id: 'lng', label: 'Longitude', hidden: true },
  { id: 'id', label: 'ID', hidden: true },
  { id: 'status', label: 'Status', hidden: true },
  { id: 'primary_color', label: 'Primary Color', hidden: true },
  { id: 'secondary_color', label: 'Secondary Color', hidden: true },
  {
    id: 'actions',
    label: 'Actions',
    disableCLick: true,
    notSortable: true,
    shouldNotExport: true,
    format: (row: IMerchantStore) => (
      <Stack justifyContent="flex-start" alignItems="flex-start">
        <IconButtonMenu
          buttons={[
            {
              label: '',
              startIcon: <EditIcon />,
              onClick: (e: React.MouseEvent) => {
                e.stopPropagation();
                history.push(`/branded-app/merchant-locations/${row.id}/edit`);
              },
            },
          ]}
        />
      </Stack>
    ),
  },
];
